
export enum EstadosOrdenServicioEnumChoice {
  CANCELADO = 'CANCELADO',
  EN_PROCESO = 'EN_PROCESO',
  FINALIZADO = 'FINALIZADO',
  PENDIENTE = 'PENDIENTE',
  EN_ESPERA = 'EN ESPERA',
}

export enum TipoOrdenServicioEnumChoice {
  TRASLADO = 'TRASLADO',
  RAZON_SOCIAL = 'CAMBIO RAZON SOCIAL',
  TODOS = 'TODOS',
  VISITA = 'VISITA',
  REPARACION = 'REPARACION',
}